/* eslint-disable max-len */
import { Spinner } from "../../../../../../v1/components/atoms/Spinner/Spinner";
import { TaskStatus } from "../../../../pages/Tasks/MyTasks/utils/constants";

interface ITaskStatusIcon {
  status: TaskStatus;
}
export const TaskStatusIcon: React.FC<ITaskStatusIcon> = ({ status }) => {
  const colors: { [key in TaskStatus]: string } = {
    [TaskStatus.CANCELLED]: "#a1aab2",
    [TaskStatus.COMPLETED]: "#5fb188",
    [TaskStatus.FAILED]: "#cc4747",
    [TaskStatus.WARNING]: "#cc4747",
    [TaskStatus.PENDING]: "#a1aab2",
    [TaskStatus.QUEUED]: "#f88a29",
    [TaskStatus.SCHEDULED]: "#a1aab2",
    [TaskStatus.STARTED]: "#f88a29",
  };

  const withSpinner = [TaskStatus.QUEUED, TaskStatus.STARTED];
  if (withSpinner.includes(status)) return <Spinner />;

  return (
    <svg viewBox="150.0483 119.395 242.3179 241.957" width="242.3179" height="241.957">
      <path
        fill={colors[status] || "currentColor"}
        d="M 271.207 361.352 C 364.336 361.352 422.542 260.537 375.978 179.884 C 354.367 142.454 314.428 119.395 271.207 119.395 C 178.078 119.395 119.872 220.211 166.437 300.863 C 188.048 338.294 227.986 361.352 271.207 361.352 Z M 271.207 195.006 C 306.131 195.006 327.958 232.812 310.496 263.057 C 302.392 277.094 287.415 285.74 271.207 285.74 C 236.283 285.74 214.456 247.935 231.918 217.69 C 240.022 203.654 254.999 195.006 271.207 195.006 Z"
      ></path>
    </svg>
  );
};
